import { z } from "zod";
import { isPoBoxAddress } from "@common/helpers/address";

/**
 * US address form schema with an optional Street 2 line (Street, Street 2,
 * City, State, Postal code). Only US-based entities are supported for now,
 * so there is no country field — state is always required.
 */
export function getFullAddressFormSchema(allowPoBox: boolean) {
    return z.object({
        street: allowPoBox
            ? z.string().min(1, "Street is required")
            : z
                  .string()
                  .min(1, "Street is required")
                  .refine((v) => !isPoBoxAddress(v), "PO boxes not allowed"),
        street2: z.string().optional(),
        city: z.string().min(1, "City is required"),
        state: z.string().min(1, "Required"),
        postalCode: z
            .string()
            .min(1, "Required")
            .regex(/^\d{5}$/, "Provide 5 digits"),
    });
}
